export const BASE_API = {
  // Auth
  login: "/users/login", //ok
  createRoom: "/chat/rooms", //ok
  updateUserPass: "/users/admin/reset-user-password", //ok
  getAllNotifications: "/users/notification/get-all", //ok

  //Regional hubs->division
  createDivision: "/division/create-division",
  getDivision: "/division/get-divisions", // ok
  getSingleDivision: "/division/get-division-by",
  updateDivision: "/division/update-division-by",
  deleteDivision: "/division/delete-division-by",
  //Regional hubs->district
  createDistrict: "/district/create-district",
  getDistrict: "/district/get-districts", //ok
  getSingleDistrict: "/district/get-district-by",
  updateDistrict: "/district/update-district-by",
  deleteDistrict: "/district/delete-district-by",
  //Regional hubs->police station
  createPoliceStation: "/police-station/create-police-station",
  getPoliceStation: "/police-station/get-police-stations", //ok
  updatePoliceStation: "/police-station/update-police-station-by",
  //Regional hubs->regional hub
  createRegionalHub: "/regional-hub/create-regional-hub", //ok
  getRegionalHub: "/regional-hub/get-regional-hubs", // ok
  updateRegionalHub: "/regional-hub/update-regional-hub", //ok

  // Category
  createCategory: "/category/create",
  getAllCategory: "/category/get-all", //ok
  updateCategory: "/category/update-by",

  //dashboard
  dashboard: "/users/admin/dashboard-count", //ok

  // cso->user
  createUser: "/users/create-user", //ok
  getAllUsers: "/users/cso/get-users", //ok
  getSingleUser: "/users/admin/get-user-by", //ok
  updateUser: "/users/admin/update-user-by", //ok

  getAllRooms: "/chat/get-all-rooms",
  getSingleRooms: "/chat/rooms-admin",

  // cso->role
  createRole: "/roles/create-role", //ok
  getAllRoleList: "/roles/get-roles", //ok

  // Event Manage -> Event
  createEvent: "/events/admin/create-event", //ok
  getAllEvents: "/events/admin/get-events", //ok
  updateEvent: "/events/admin/update-event-by", //ok
  updateEventStatus: "/events/admin/update-status",
  getSingleEvent: "/events/admin/get-event-by", //ok
  // Event Manage -> Webinars
  createWebinar: "/events/admin/create-webinar", //ok
  getAllWebinars: "/events/admin/get-webinars", //ok
  updateWebinar: "/events/admin/update-webinar-by", //ok
  getSingleWebinar: "/events/admin/get-webinar-by", //ok
  // Event Manage -> Pending Request
  getAllPending: "/events/admin/get-all-pending", //ok
  updateAnyStatus: "/events/admin/update-status", //common , ok
  deleteEvent: "/events/admin/delete-event-by", //ok
  deleteWebinar: "/events/admin/delete-webinar-by", //ok
  deleteCampaign: "/events/admin/delete-campaign-by", //ok
  // Event Manage -> Campaigns
  createCampaign: "/events/admin/create-campaign", //ok
  getAllCampaigns: "/events/admin/get-campaigns", //ok
  updateCampaign: "/events/admin/update-campaign-by", //ok
  getSingleCampaign: "/events/admin/get-campaign-by", //ok

  //content management
  createPublication: "/content-management/publication/create", //ok
  getAllPublication: "/content-management/publication/get-all", //ok
  getSinglePublication: "/content-management/publication/get-single-by", //ok
  updatePublication: "/content-management/publication/update-by", //ok

  // Training Materials
  createTrainingMaterial: "/training-material/create", //ok
  getAllTrainingMaterial: "/training-material/get-all", //ok
  getSingleTrainingMaterial: "/training-material/get-single-by", //ok
  updateTrainingMaterial: "/training-material/update-by", //ok

  // Community Forum
  createCommunityForum: "/community-forum/create", //ok
  getAllCommunityForum: "/community-forum/get-all", //ok
  updateCommunityForum: "/community-forum/update-status-by", //ok
  getSingleCommunityForum: "/community-forum/get-by", //ok
  toggleLikeForum: "/community-forum/toggle-like", //ok

  // discussion board
  createDiscussionBoard: "/discussion-board/create", //ok
  getAllDiscussionBoard: "/discussion-board/get-all", //ok
  getSingleDiscussionBoard: "/discussion-board/get-by", //ok
  updateDiscussionBoard: "/discussion-board/update-status-by", //ok
  toggleLikeDiscussionBoard: "/discussion-board/toggle-like", //ok

  // donation
  createDonation: "/donation/create", //ok
  getAllDonation: "/donation/get-all", //ok
  exportDonation: "/donation/export", //ok

  //webCMS -> home
  getHomeSlider: "/website-cms/get-homepage-slider", //ok
  getHomeAbout: "/website-cms/get-homepage-aboutsushil", //ok
  getHomeOurReach: "/website-cms/get-homepage-ourreach", //ok
  getHomeSocialMedia: "/website-cms/get-homepage-social-media-links", //ok

  updateHomeSlider: "/website-cms/update-homepage-slider", //ok
  updateHomeAbout: "/website-cms/update-homepage-aboutsushil", //ok
  updateHomeOurReach: "/website-cms/update-homepage-ourreach", //ok
  updateHomeSocialMedia: "/website-cms/update-homepage-social-media-links", //ok

  //webCMS -> About us
  getHomeMissionVision: "/website-cms/get-aboutus-mission-vision", //ok
  getHomeLeadership: "/website-cms/get-aboutus-leadership", //ok
  getHomeHowWeWork: "/website-cms/get-aboutus-how-we-work", //ok
  getHomePartnership: "/website-cms/get-aboutus-partnership-development", // ok
  getHomeBecomePartner: "/website-cms/get-aboutus-become-sushil-partner", //ok
  getHomeGovernance: "/website-cms/get-aboutus-governance", //ok
  getHomeContribution: "/website-cms/get-aboutus-contribution", //ok
  getHomeAwards: "/website-cms/get-aboutus-awards-recognition", //ok

  updateHomeMissionVision: "/website-cms/update-aboutus-mission-vision", //ok->nested problem
  updateHomeLeadership: "/website-cms/update-aboutus-leadership", //ok
  updateHomeHowWeWork: "/website-cms/update-aboutus-how-we-work", //ok -> image problem
  updateHomePartnership: "/website-cms/update-aboutus-partnership-development", // some problem
  updateHomeBecomePartner: "/website-cms/update-aboutus-become-sushil-partner", //ok
  updateHomeGovernance: "/website-cms/update-aboutus-governance", //ok
  updateHomeContribution: "/website-cms/update-aboutus-contribution", //ok
  updateHomeAwards: "/website-cms/update-aboutus-awards-recognition", //image update problem
  deletePartnerImage: "/website-cms/delete-partnership-development-image",
  //webCMS -> Gallery
  getHomeGallery: "/website-cms/get-gallery", // *
  updateHomeGallery: "/website-cms/update-gallery", //ok
  //webCMS -> Header
  getHomeHeader: "/website-cms/get-header", //ok
  updateHomeHeader: "/website-cms/update-header", //ok
  //webCMS -> Footer
  getHomeFooter: "/website-cms/get-footer", //ok
  updateHomeFooter: "/website-cms/update-footer", //ok

  //settings
  getAccessLog: "/users/admin/access-logs", //ok
  getUserDetails: "/users/cso/me", //ok
  updatePassword: "/users/admin/update-password",
  getActivityLog: "/users/admin/activity-logs", //ok

  // (File Upload)
  fileUpload: "/users/file-or-image-upload", //ok
};
